function t(t){return!!t.type.isSelectable&&!t.props.disabled}var e=function(t,e,n){return e.props.id||"".concat(t,"-item-").concat(n)};export{e as generateMenuItemId,t as isMenuChildSelectable};
//# sourceMappingURL=utils.js.map
